import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import withNotLogged from '../hocs/withNotLogged';
import Nav from '../components/Nav';

const LayoutSetting = () => {
    return (
        <>
            <Header />
            <Nav />
            <div className="container-fluid">
                <div className="profile">
                    <Sidebar />
                    <Outlet />
                </div>
            </div>
        </>
    );
};

export default withNotLogged(LayoutSetting);
